module.exports = __webpack_public_path__ + "static/img/10.152701e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/10.png
// module id = fBvD
// module chunks = 0